import { render, staticRenderFns } from "./ClosedIncidencesList.vue?vue&type=template&id=77f42678&"
import script from "./ClosedIncidencesList.vue?vue&type=script&lang=js&"
export * from "./ClosedIncidencesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports